<template>
	<div class="videolist">
		<div class="breadcrumb">抢购商品列表</div>
		<div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加抢购商品</el-button>
			<el-button size='small' type="warning" @click="edit" plain>修改</el-button>
			<el-button size='small' type="danger" @click="del" plain>删除</el-button>
			<div class="topinput">
				<input type="text" name="" placeholder="商品名称" v-model="productName" class="el-input__inner" @keyup.enter="search_mine"/>
			</div>
		    <el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
		    <el-table-column prop="id" label="商品ID"></el-table-column>
		    <el-table-column prop="productPicUrl" label="商品图片">
		    	<template slot-scope="scope">
	            	<div class="imgWidth" v-if="scope.row.productPicUrl">
	            		<img :src="scope.row.productPicUrl"  />
	            	</div>
	            </template>
		    </el-table-column>
		    <el-table-column prop="productName" label="商品名称"></el-table-column>
		    <el-table-column prop="saleType" label="商品类型">
		    	<template slot-scope="scope">
	            	{{scope.row.saleType==1?'团购商品':scope.row.saleType==2?'秒杀商品':scope.row.saleType==3?'砍价商品':'普通商品'}}
	            </template>
		    </el-table-column>
		    <el-table-column prop="remainingAmount" label="可抢数量"></el-table-column>
		    <el-table-column prop="sort" label="排序"></el-table-column>
		    <el-table-column prop="status" label="状态">
		    	<template slot-scope="scope">
		    		{{scope.row.status==0?'下架':'上架'}}
		    	</template>
		    </el-table-column> 
		    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建日期" ></el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>

		<!-- 添加抢购商品弹框 -->
    	<el-dialog :title="currentRow?'修改抢购商品':'添加抢购商品'" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="120px">
      			<el-form-item label="商品类型" prop="saleType">
				    <el-radio-group v-model="ruleForm.saleType" @change="changesaleType">
				      	<el-radio :label='1'>团购商品</el-radio>
				      	<el-radio :label='2'>秒杀商品</el-radio>
				      	<el-radio :label='3'>砍价商品</el-radio>
				      	<el-radio :label='4'>普通商品</el-radio>
				    </el-radio-group>
				</el-form-item>
				<input type="hidden" v-model="ruleForm.goodsId">
      			<el-form-item label="选择商品" prop="productName">
      				<i class="el-icon-edit"></i>
		          	<label @click="selUserDialog()">{{ruleForm.productName}}</label>	
				</el-form-item>

      			<el-form-item label="商品链接" prop="productDetailUrl">
				    <el-input v-model="ruleForm.productDetailUrl" style="width: 80%;" placeholder="请输入商品链接" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item label="商品图片" prop="productPicUrl">
				    <el-input v-model="ruleForm.productPicUrl" style="width: 80%;" placeholder="请输入商品图片链接"></el-input>
				</el-form-item>

				<!-- 视频封面 -->
	        	<el-form-item label="视频封面" prop="productVideoPicUrl">
		          	<el-input v-model="ruleForm.productVideoPicUrl" placeholder="请输入视频封面图片链接" style="width: 80%;" @input="change($event)"></el-input>
		          	<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
		            	<img v-if="ruleForm.productVideoPicUrl" :src="ruleForm.productVideoPicUrl" class="avatar" />
		            	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		          	</el-upload>
		        </el-form-item>

		        <!-- 视频链接 -->
	        	<el-form-item label="视频链接" prop="productVideoUrl">
		          	<el-input v-model="ruleForm.productVideoUrl" placeholder="请输入视频链接" style="width: 80%;" @input="change($event)"></el-input>
		          	<el-upload class="avatar-uploader" :action="tmpFiles" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess" :on-progress="uploadVideoProcess">
	            		<video v-if="ruleForm.productVideoUrl && videoFlag == false" :src="ruleForm.productVideoUrl" width="100%" height="180" controls="controls" style="position: relative;top: -50px;">您的浏览器不支持视频播放</video>
			            <i v-if="videoFlag == false && !ruleForm.productVideoUrl" class="el-icon-plus avatar-uploader-icon"></i>
			            <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" :width="widthw"></el-progress>
	          		</el-upload>
		        </el-form-item>

			  	<el-form-item label="可抢数量" prop="remainingAmount">
				    <el-input v-model.number="ruleForm.remainingAmount" placeholder="仅支持输入数字" style="width: 80%;" @input="change($event)"></el-input>
				</el-form-item>
		        <el-form-item label="开抢时间" prop="saleStartTime">
				    <el-date-picker
				      	v-model="ruleForm.saleStartTime"
				      	type="datetime"
				      	placeholder="请选择日期"
				      	value-format="timestamp"
				      	:picker-options="start_Date" style="width: 80%;">
				    </el-date-picker>
				</el-form-item>
		        <el-form-item label="结束时间" prop="saleEndTime">
				    <el-date-picker
				      	v-model="ruleForm.saleEndTime"
				      	type="datetime"
				      	placeholder="请选择日期"
				      	value-format="timestamp"
				      	:picker-options="end_Date" style="width: 80%;">
				    </el-date-picker>
				</el-form-item>
				<el-form-item label="原价" prop="originalPrice">
				    <el-input v-model="ruleForm.originalPrice" placeholder="仅支持输入数字，单位：元" style="width: 80%;" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item label="抢购价" prop="salePrice">
				    <el-input v-model="ruleForm.salePrice" placeholder="仅支持输入数字，单位：元" style="width: 80%;" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item label="排序" prop="sort">
				    <el-input v-model.number="ruleForm.sort" placeholder="仅支持输入数字，数字越小越靠前" style="width: 80%;"></el-input>
				</el-form-item>
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
		    </span>
    	</el-dialog>

    	<!-- 请选择商城商品 -->
    	<el-dialog title="商城商品" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose2">
      		<el-scrollbar style="height:500px; width:100%;">
		        <template>
		          	<el-table ref="multipleTable" :data="goodsData" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange2">
		            	<el-table-column prop="goods_id" label="商品ID">
		            		<template slot-scope="scope">
		            			{{ruleForm.saleType!=2?scope.row.goods_id:scope.row.sharp_goods_id}}
				            </template>
		            	</el-table-column>
		            	<el-table-column label="商品名称" show-overflow-tooltip>
		            		<template slot-scope="scope">
		            			{{ruleForm.saleType!=3?scope.row.goods_name:scope.row.goods.goods_name}}
				            </template>
		            	</el-table-column>
		            	<el-table-column prop="goods_image" label="商品图片">
		            		<template slot-scope="scope">
				            	<div class="imgWidth">
				            		<img :src="ruleForm.saleType!=3?scope.row.goods_image:scope.row.goods.goods_image" />
				            	</div>
				            </template>
		            	</el-table-column>

		            	<el-table-column label="商品原价">
		            		<template slot-scope="scope">
		            			{{
		            				ruleForm.saleType==1?
		            				'￥'+scope.row.goods_sku.goods_price:
		            				ruleForm.saleType==2?
		            				'￥'+scope.row.goods_sku.original_price:
		            				ruleForm.saleType==3?
		            				'￥'+scope.row.goods.goods_sku.goods_price:'￥'+scope.row.goods_sku.line_price
		            			}}
				            </template>
		            	</el-table-column>
		            	<el-table-column prop="goods_id" label="小程序销售价">
		            		<template slot-scope="scope">
		            			{{
		            				ruleForm.saleType==1?
		            				'￥'+scope.row.goods_sku.sharing_price:
		            				ruleForm.saleType==2?
		            				'￥'+scope.row.goods_sku.seckill_price:
		            				ruleForm.saleType==3?
		            				'￥'+scope.row.floor_price:'￥'+scope.row.goods_sku.goods_price
		            			}}
				            </template>
		            	</el-table-column>
		          	</el-table>
		        </template>
	        	<div class="block" style="padding:30px 10px; float:right" @click.stop>
	          		<el-pagination @current-change="handleCurrentChangePage2" :current-page="pageNum2" :page-size="per_page" layout="total, prev, pager, next, jumper" :total="totalPage2"></el-pagination>
	        	</div>
      		</el-scrollbar>
    	</el-dialog>

	</div>
</template>

<script>
export default {
  	mounted() {
  		this.init(); 
  		console.log(location.hostname)
  		this.mallurl=location.hostname=='back.xqiaotv.com'?'https://apimall.xqiaotv.com':'https://apimall.xqiaotech.com'
  		//this.goodslists();	
  	},
  	data() {
  		var originalPricePass = (rule, value, callback) => {//包含小数的数字
            let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
            if (value === '') {
                callback(new Error('请输入原价'));
            } else if (!reg.test(value)) {
                callback(new Error('原价必须为数字值'));
            } else {
                callback();
            }
        };
        var salePricePass = (rule, value, callback) => {//包含小数的数字
            let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
            if (value === '') {
                callback(new Error('请输入抢购价'));
            } else if (!reg.test(value)) {
                callback(new Error('抢购价必须为数字值'));
            } else {
                callback();
            }
        };
    	return {
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
		    per_page:15,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tmpFiles: process.env.API_ROOT + "/tmpFiles",
	      	videoFlag: false, //刚开始的时候显示为flase
	      	videoUploadPercent: "0%", //进度条刚开始的时候为0%
	      	tableData3: [],
	      	dialogVisible: false,
	      	currentRow:'',
	      	productName:'',
	      	ruleForm: {
	      		productName:'点击选择商品',
	      		productVideoPicUrl:'',
	      		productVideoUrl:''
      		},
      		mallurl:'',
      		pageNum2:1,
      		totalPage2:10,
      		dialogVisible2:false,
      		goodsData:[],//商城商品
      		shopUrl:'',
      		rules:{
      			saleType:[
      				{ required: true, message: '请选择商品类型', trigger: 'change' }
      			],
      			productName: [
		            { required: true, message: '请输入商品名称', trigger: 'blur' }
		        ],
      			productDetailUrl: [
		            { required: true, message: '请输入商品链接', trigger: 'blur' }
		        ],
		        
		        productPicUrl: [
		            { required: true, message: '请输入商品图片链接', trigger: 'blur' }
		        ],
		        productVideoPicUrl: [
		            { required: true, message: '请输入视频封面图片链接', trigger: 'blur' }
		        ],
		        productVideoUrl: [
		            { required: true, message: '请输入视频链接', trigger: 'blur' }
		        ],
		        remainingAmount: [
		            { required: true, message: '请输入可抢数量', trigger: 'blur' },
		            { type: 'number', message: '可抢数量必须为数字值'}
		        ],
		        saleStartTime: [
	            	{ type: 'date', required: true, message: '请选择开抢时间', trigger: 'change' }
	          	],
	          	saleEndTime: [
	            	{ type: 'date', required: true, message: '请选择结束时间', trigger: 'change' }
	          	],
	          	originalPrice: [
		            { required: true, validator:originalPricePass, trigger: "blur" }
		        ],
		        salePrice: [
		            { required: true, validator:salePricePass, trigger: "blur" }
		        ],
		        sort: [
		            { required: true, message: '请输入排序', trigger: 'blur' },
		            { type: 'number', message: '排序必须为数字值'}
		        ],
      		},
        	start_Date: { //时间限制
		       	disabledDate: time => {
	                if(this.ruleForm.validEndTime) {
	                    return time.getTime() < Date.now()-8.64e7 || time.getTime() > this.ruleForm.validEndTime;
	                }   
	                return time.getTime() < Date.now()-8.64e7;
	            }
		    },
		    end_Date: {
	            disabledDate: time => {
	                return time.getTime() < Date.now()-8.64e7 || time.getTime() < this.ruleForm.validStartTime;
	            }
		  	},
		  	widthw:100
	    };
  	},
  	methods:{
  		changesaleType(val){
  			this.$refs.ruleForm.clearValidate();
  			this.dialogVisible2=false;
  			this.shopUrl=
  			(val==1)?'/index.php?s=/api/sharing.goods/listsAll':
  			(val==2)?'/index.php?s=/api/sharp.goods/allGoods':
  			(val==3)?'/index.php?s=/api/bargain.active/index':'/index.php?s=/api/goods/lists';
  			this.ruleForm={
		        productName:'点击选择商品',
		        saleType:val 
	      	}
  		},
  		change(e){
  			this.$forceUpdate()
  		},
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		productName:this.productName
      		};
      		this.$get("/shoppingMall/queryProductsPromotionList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		goodslists(){//列表
  			var that=this;
  			that.$request({
			    url: that.mallurl+that.shopUrl,
			    method: 'POST',
			    data: {
		            page: that.pageNum2,
		            wxapp_id: 10001,
		            //sortType:'all'
		        },
			    success: function(res) {
		            console.log(res);
		            if (res.code == 1) {
		            	that.goodsData=res.data.list.data;
		            	that.per_page=res.data.list.per_page;
		            	that.totalPage2 = res.data.list.total;
		            }else {
	            		that.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
		        }
			})	
  		},
  		//选择需要修改的权限
	    handleCurrentChange(val) {
	      	if (val) {
	        	this.currentRow = val;
	      	}
	    },
  		search_mine(){
  			this.pageNum=1;
  			this.init()
  		},
  		//当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	      		this.ruleForm={
			        productName:'点击选择商品'
		      	}
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.currentRow='';
	      	this.dialogVisible = true;
  		},
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	      		this.ruleForm={
			        productName:'点击选择商品'
		      	}
	        	//this.$refs.ruleForm.resetFields();
	      	}
	      	done();
	    },
	    onSubmit(formName) {
	    	console.log(this.ruleForm)
	    	//return false	    
	    	this.$refs[formName].validate((valid) => {
	          	if (valid) {	            	
	            	this.$post("/shoppingMall/addProductsPromotion", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: this.ruleForm.id?'修改成功':'添加成功',
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	} else {
	            	console.log('error submit!!');
	            	return false;
	          	}
	        });

    	},
    	edit() {
	      	if (this.currentRow.id) {
	        	this.ruleForm=this.currentRow;
	        	this.shopUrl=
	  			(this.currentRow.saleType==1)?'/index.php?s=/api/sharing.goods/listsAll':
	  			(this.currentRow.saleType==2)?'/index.php?s=/api/sharp.goods/allGoods':
	  			(this.currentRow.saleType==3)?'/index.php?s=/api/bargain.active/index':'/index.php?s=/api/goods/lists';
	        	this.ruleForm.originalPrice=this.currentRow.originalPriceSwitch;
	        	this.ruleForm.salePrice=this.currentRow.salePriceSwitch;
	        	this.dialogVisible = true;
	      	} else {
	        	this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    del(val) {
	    	var that=this;
	      	if (that.currentRow.id) {
	        	that.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
	          	})
	          	.then(() => {
	            	that.$post("/shoppingMall/delProductsPromotion", JSON.stringify(that.currentRow))
	              	.then(function(res) {
	                	console.log(res);
	                	if (res.code == 0) {
	                  		console.log(" 删除成功 ");
	                  		that.$message({
	                    		message: "删除成功",
	                    		type: "success"
	                  		});
	                  		that.currentRow='';
	                  		that.pageNum = 1;
	                  		that.init();
	                  		that.dialogVisible = false;
	                	} else {
	                  		that.errorMsg("操作失败");
	                	}
	              	})
	          	})
	      	} else {
		        that.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    handleCurrentChange2(val) {//商城商品用户行
	    	console.log(val);
	      	if (val) {
	      		this.dialogVisible2 = false;
	        	//商品名称
	        	this.ruleForm.productName=(this.ruleForm.saleType!=3)?val.goods_name:val.goods.goods_name;
	        	//商品图片
	        	this.ruleForm.productPicUrl=(this.ruleForm.saleType!=3)?val.goods_image:val.goods.goods_image;
	        	//id
	        	this.ruleForm.goodsId =(this.ruleForm.saleType!=2)?val.goods_id:val.sharp_goods_id;//秒杀id

	        	//可抢数量//销售价//原价
	        	if(this.ruleForm.saleType==1){//团购
	        		this.ruleForm.remainingAmount=val.goods_sku.stock_num;//可抢数量
	        		this.ruleForm.salePrice = val.goods_sku.sharing_price;//销售价
	        		this.ruleForm.originalPrice = val.goods_sku.goods_price;//原价
	        		this.ruleForm.productVideoPicUrl=val.video_image.file_path//视频封面图
	        		this.ruleForm.productVideoUrl=val.video.file_path//视频URL
	        	}else if(this.ruleForm.saleType==2){//秒杀
	        		this.ruleForm.remainingAmount=val.seckill_stock;//可抢数量
	        		this.ruleForm.salePrice = val.goods_sku.seckill_price;//销售价
	        		this.ruleForm.originalPrice = val.goods_sku.original_price;//原价
	        		this.ruleForm.productVideoPicUrl=val.goods.video_image.file_path//视频封面图
	        		this.ruleForm.productVideoUrl=val.goods.video.file_path//视频URL
	        	}else if(this.ruleForm.saleType==3){//砍价
	        		this.ruleForm.remainingAmount=val.goods.goods_sku.stock_num;//可抢数量
	        		this.ruleForm.salePrice = val.floor_price;//销售价
	        		this.ruleForm.originalPrice = val.goods.goods_sku.goods_price;//原价
	        		this.ruleForm.productVideoPicUrl=val.goods.video_image.file_path//视频封面图
	        		this.ruleForm.productVideoUrl=val.goods.video.file_path//视频URL
	        	}else if(this.ruleForm.saleType==4){
	        		this.ruleForm.remainingAmount=val.goods_sku.stock_num;//可抢数量
	        		this.ruleForm.salePrice = val.goods_sku.goods_price;//销售价
	        		this.ruleForm.originalPrice = val.goods_sku.line_price;//原价
	        		this.ruleForm.productVideoPicUrl=val.video_image.file_path//视频封面图
	        		this.ruleForm.productVideoUrl=val.video.file_path//视频URL
	        	}

	        	//跳转地址
	        	this.ruleForm.productDetailUrl=
	        	(this.ruleForm.saleType==1)?'pages/sharing/goods/index?goods_id='+val.goods_id:
	        	(this.ruleForm.saleType==3)?'pages/bargain/goods/index?active_id='+val.active_id:
	        	(this.ruleForm.saleType==4)?'pages/goods/index?goods_id='+val.goods_id:''
	        	
	      	}
	    },
	    handleCurrentChangePage2(val) {//当前页数
	      	this.pageNum2 = val;
	      	this.goodslists();
	    },
	    handleClose2() {//商城商品
	      this.dialogVisible2 = false;
	    },
	    //
	    selUserDialog() {
	    	console.log(this.ruleForm.saleType)
	    	if(this.shopUrl && this.ruleForm.saleType){
	    		this.dialogVisible2 = true;
	    		this.goodslists();
	    	}else{
	    		this.$message({
		          	message: "请选择商品类型",
		          	type: "warning"
		        });
		        return false;
	    	}  	
	    },
	    beforeAvatarUpload(file){
	    	const isJPG = file.type === "image/jpeg";
	      	//const isLt2M = file.size / 1024 < 20;
	      	if (!isJPG) {
	      	  	this.$message.error('上传封面只能是 JPG 格式');
	      	  	return false
	      	}
	      	// if (!isLt2M) {
	       //  	this.$message.error("上传封面大小不能超过 20kb!");
	      	// }
	      	return isJPG;
	    },
	    //选择视频封面成功
	    handleAvatarSuccess(res, file) {
	      	this.ruleForm.productVideoPicUrl = res.data.url;
	    },
	    beforeUploadVideo(file){
	    	console.log(file)
	    	const isMP4 = file.type === "video/mp4";
	      	//const isLt2M = file.size / 1024 < 20;
	      	if (!isMP4) {
	      	  	this.$message.error('上传视频只能是 MP4 格式');
	      	  	return false
	      	}
	      	// if (!isLt2M) {
	       //  	this.$message.error("上传封面大小不能超过 20kb!");
	      	// }
	      	return isMP4;
	    },
	    uploadVideoProcess(event, file, fileList) {
	      	this.videoFlag = true;
	      	this.videoUploadPercent = parseInt(file.percentage);
	    },
	    //选择视频封面成功
	    handleVideoSuccess(res, file) {
	    	this.videoFlag = false;
	      	this.videoUploadPercent = 0;
	      	this.ruleForm.productVideoUrl = res.data.url;
	    },
  	}
}
</script>
<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.el-radio{
	margin-right: 15px
}
.convert_input{
	margin: 0 10px
}
.topinput{
	position: relative;
	margin:0  15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
.imgWidth{
	width: 50px;
	height: 50px;
	border:1px solid #ccc;
	display:flex;
  	align-items:center;
}
.imgWidth img,.avatar{
	max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/commodityManagement/index.vue